import { render, staticRenderFns } from "./FlowVarList.vue?vue&type=template&id=bc63a49e&scoped=true&"
import script from "./FlowVarList.vue?vue&type=script&lang=js&"
export * from "./FlowVarList.vue?vue&type=script&lang=js&"
import style0 from "./FlowVarList.vue?vue&type=style&index=0&id=bc63a49e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc63a49e",
  null
  
)

export default component.exports